import appConfig from '~/config/app'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'

export const EXAM_CAMPAIGN_FLAG = 'exam-campaign-2026'

export const EXAM_CAMPAIGN_COUNTRY_CODES: string[] = [
  CurriculumCountryCodes.USA.toUpperCase(),
  CurriculumCountryCodes.NORWAY.toUpperCase(),
]

// Stripe coupon Fc9mKPhB: 8.33% off once, restricted to the standard yearly product.
export const EXAM_CAMPAIGN_YEARLY_PROMO: ExamCampaignPromo = {
  code: 'EXAM2026',
  promotionId: appConfig.isProdEnvironment ? 'promo_1UWEmWJhgnSRU9kuk7Cevfip' : 'promo_1UWEnZJhgnSRU9kuogG0ePnU',
}

export interface ExamCampaignPromo {
  code: string
  promotionId: string
}

export interface ExamCampaignGeoOffer {
  before: { base: number; license: number }
  stickerBefore: string
  stickerPrice: string
  compact?: boolean
  yearlyPromo?: ExamCampaignPromo
}

// The sticker's numbers follow the visitor's geo location, not the site language
export const EXAM_CAMPAIGN_BY_GEO: Record<string, ExamCampaignGeoOffer> = {
  [CurriculumCountryCodes.USA.toUpperCase()]: {
    before: { base: 12, license: 10 },
    stickerBefore: '$12',
    stickerPrice: '$10',
  },
  [CurriculumCountryCodes.NORWAY.toUpperCase()]: {
    before: { base: 119, license: 99 },
    stickerBefore: '119 kr',
    stickerPrice: '69 kr',
    compact: true,
    ...(appConfig.isProdEnvironment && {
      yearlyPromo: { code: 'gn67oVGt', promotionId: 'promo_1UXGL2JhgnSRU9kudAKV1z30' },
    }),
  },
}

export const examBeforeYearlyTotal = ({ before }: ExamCampaignGeoOffer, learners: number): number =>
  (before.base + before.license * Math.max(learners - 1, 0)) * 12
